import SwapVertIcon from '@mui/icons-material/SwapVert';
import { MenuItem, Select, SelectChangeEvent } from '@mui/material';
import css from './MediaDataGrid.module.scss';

export type SortOption = 'newest' | 'oldest' | 'longest' | 'shortest';

export const SORT_OPTIONS: Record<
  SortOption,
  { label: string; field: string; sort: 'asc' | 'desc' }
> = {
  newest: { label: 'Newest first', field: 'publishedAt', sort: 'desc' },
  oldest: { label: 'Oldest first', field: 'publishedAt', sort: 'asc' },
  longest: { label: 'Longest first', field: 'duration', sort: 'desc' },
  shortest: { label: 'Shortest first', field: 'duration', sort: 'asc' },
};

interface SortSelectorProps {
  sortOption: SortOption;
  onChange: (event: SelectChangeEvent<SortOption>) => void;
}

export const SortSelector = ({ sortOption, onChange }: SortSelectorProps) => {
  return (
    <Select
      value={sortOption}
      onChange={onChange}
      onClose={() => {
        // Blur the Select when menu closes to remove focused state
        setTimeout(() => {
          (document.activeElement as HTMLElement)?.blur();
        }, 0);
      }}
      className={css.sortSelect}
      IconComponent={() => null}
      renderValue={(value) => (
        <div className={css.sortSelectValue}>
          <SwapVertIcon className={css.sortIcon} />
          <span className={css.sortByLabel}>Sort by:</span>
          <span className={css.sortByValue}>{SORT_OPTIONS[value].label}</span>
        </div>
      )}
      MenuProps={{
        slotProps: { paper: { className: css.sortMenu } },
      }}
    >
      {(Object.keys(SORT_OPTIONS) as SortOption[]).map((key) => (
        <MenuItem key={key} value={key} className={css.sortMenuItem}>
          {SORT_OPTIONS[key].label}
        </MenuItem>
      ))}
    </Select>
  );
};
